// extracted by mini-css-extract-plugin
module.exports = {"flipContainer":"NtjVR","cardWrap":"slqiu","flip":"RKPUE","flipCard":"QvSW8","cardFront":"wBAD9","cardBack":"Fxytm"};